/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface MetierSearch
 */
export interface MetierSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof MetierSearch
     */
    masculin?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof MetierSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof MetierSearch
     */
    idstade?: Int32ListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof MetierSearch
     */
    conseiller?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof MetierSearch
     */
    integre?: BooleanSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof MetierSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof MetierSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MetierSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetierSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof MetierSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof MetierSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetierSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof MetierSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MetierSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the MetierSearch interface.
 */
export function instanceOfMetierSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetierSearchFromJSON(json: any): MetierSearch {
    return MetierSearchFromJSONTyped(json, false);
}

export function MetierSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetierSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'masculin': !exists(json, 'masculin') ? undefined : TextSearchFromJSON(json['masculin']),
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'idstade': !exists(json, 'idstade') ? undefined : Int32ListSearchFromJSON(json['idstade']),
        'conseiller': !exists(json, 'conseiller') ? undefined : TextSearchFromJSON(json['conseiller']),
        'integre': !exists(json, 'integre') ? undefined : BooleanSearchFromJSON(json['integre']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function MetierSearchToJSON(value?: MetierSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'masculin': TextSearchToJSON(value.masculin),
        'code': TextSearchToJSON(value.code),
        'idstade': Int32ListSearchToJSON(value.idstade),
        'conseiller': TextSearchToJSON(value.conseiller),
        'integre': BooleanSearchToJSON(value.integre),
        'actif': BooleanSearchToJSON(value.actif),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

